import {Component, OnInit} from '@angular/core';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {TypeaheadMatch} from 'ngx-bootstrap';

@Component({
  selector: 'reporte-vencimiento',
  templateUrl: '../templates/inventarios/reporte.vencimientos.template.html'
})
export class ReporteVencimientosComponent implements OnInit {

  public tiendas: TiendaEntity[] = [];
  public tiendaSelect: TiendaEntity;
  public tSelectName: string = '';
  public tituloReport: string = '';

  constructor(private ss: SocketServices) {

  }


  ngOnInit(): void {
  }

  tiendaSeleccionada(event: TypeaheadMatch) {
    this.tiendaSelect = event.item;
  }

  consultarDatos() {
    if (this.tiendaSelect) {
      this.tituloReport = 'Reporte de Productos Descontinuados';
    }
  }


}
